import { useEffect } from 'react';
import { manageChat } from '../helpers/manageChat';
import { useTryRefreshData } from './useTryRefreshData';

export function useManageChat({ close, disabled }: { close?: boolean; disabled?: boolean }) {
  const { tryRefreshData: tryChat } = useTryRefreshData({
    refetch: () => manageChat({ close }),
    attempts: 10,
    retryTime: 100,
  });
  useEffect(() => {
    const id = setTimeout(() => {
      if (!disabled) {
        const chatWidget = manageChat({ close });
        if (!chatWidget) {
          tryChat();
        }
      }
    }, 50);
    return () => clearTimeout(id);
  }, [close, tryChat, disabled]);

  return {
    tryChat,
  };
}
